/**
 * This function is mainly used to check if affectedVersionRanges contain any "upper unbound" ranges.
 * Ranges that include a greater than without a paired less than in an affected range can cause an increase in
 * false positives.
 *
 * @param versionRanges list of version ranges
 * @returns True if any of the version ranges contain a greater than without a paired less than.
 */
export const hasUnboundUpperVersionRange = (versionRanges: string[]): boolean =>
  versionRanges.some((range) => range.includes('>') && !range.includes('<'));
